import { ReactNode } from 'react';
import { Tooltip } from '@chakra-ui/react';
import styles from './OptionalTooltip.module.css';
interface OptionalTooltip {
  content: string | undefined | null;
  children: ReactNode;
}
export const OptionalTooltip = ({
  content,
  children
}) => {
  if (!content) return children;
  return <Tooltip className={styles.tooltip} label={content} shouldWrapChildren data-sentry-element="Tooltip" data-sentry-component="OptionalTooltip" data-sentry-source-file="OptionalTooltip.tsx">
      {children}
    </Tooltip>;
};